import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface IndividualWebhookEndpoint {
  id: number;
  webhookEndpoint: string;
  webhookEventsEnabled: string;
  businessId: number;
}

export interface WebhookEndpointsForBusiness {
  configs: IndividualWebhookEndpoint[];
  success: boolean;
}

export const getWebhookEndpoints = (
  businessId: number,
): AxiosPromise<WebhookEndpointsForBusiness> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/integrations/configs`,
  });
};
